var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntentTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75434 4.73897C6.30851 4.36953 6.90156 4.23341 7.45573 4.23341C8.8849 4.23341 9.78906 5.07925 9.78906 6.25564C9.78906 7.17925 9.2349 7.64591 8.75851 8.0348C8.40851 8.33619 8.08767 8.59869 8.08767 8.98758V9.27925H6.55156V8.80286C6.55156 7.96675 7.07656 7.53897 7.52378 7.18897C7.84462 6.93619 8.12656 6.71258 8.12656 6.38203C8.12656 6.0223 7.82517 5.78897 7.26128 5.78897C6.83351 5.78897 6.20156 5.9348 5.75434 6.44036V4.73897ZM7.34878 9.64869C7.86406 9.64869 8.25295 10.0279 8.25295 10.5334C8.25295 11.039 7.86406 11.4084 7.34878 11.4084C6.82378 11.4084 6.44462 11.039 6.44462 10.5334C6.44462 10.0279 6.82378 9.64869 7.34878 9.64869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntentTooltipIcon);
export default __webpack_public_path__ + "static/media/intent-tooltip-icon.f112a4a14e0e4e9c5926d37019fe30cf.svg";
export { ForwardRef as ReactComponent };